import React from "react";

import {
  StyledBox,
  StyledBoxImg,
  StyledBoxMain,
  StyledTypography,
} from "./style";

const SocialButton = (props) => {
  const { label, icon, ...rest } = props;
  return (
    <StyledBoxMain>
      <StyledBoxImg>
        <img loading="lazy" src={icon} alt="goggleImage" />
      </StyledBoxImg>

      <StyledBox {...rest}>
        <StyledTypography>{label}</StyledTypography>
      </StyledBox>
    </StyledBoxMain>
  );
};

export default SocialButton;
